module.exports = __webpack_public_path__ + "img/icons-16-back.3181433c.svg";